import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherForCampaignNewItem_EditPage_Query = graphql(`
	query VoucherForCampaignNewItem_EditPage($hotelID: ID!) {
		voucherForCampaignNewItem(hotelID: $hotelID) {
			hotelID
			voucherID
			inSale
			name
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			voucherPrice {
				currencyType
				amount
			}
			resourceAvailablePrice {
				currencyType
				amount
			}
			voucherGiftList {
				guestName
				guestTel
				guestEmail
			}
			voucherExplanationForHost
			mailTemplate
			cinStart
			cinEnd
			createdAt
			deletedAt
		}
		hotel(hotelID: $hotelID) {
			email
		}
	}
`);
